<script lang="ts">
	//Svelte
	import { createEventDispatcher, onMount } from 'svelte';
	// Services
	import { format } from 'svelte-i18n';
	//Design System Components
	import { Modal, Container, Button, Alert } from '@Shelly/shelly-design-system';
	//Helpers
	import { getAlarmGroupedDevices, type AlarmGroupedDevices } from '../../list-helpers';
	// Types
	import type { IAlarmZone } from 'src/components/AlarmZones/AlarmWizard/alarm_object';
	import type { Device } from 'src/types/Device';
	//Components
	import AlarmBreachedSensor from './AlarmBreachedSensor.svelte';
	import { setSidePanelState } from 'src/components/Sidepanel/sidepanel-helpers';

	export let alarm: IAlarmZone;
	export let alarmsList: IAlarmZone[] = [];
	export let showModal = false;
	export let showItemsSubtitle = false;

	const dispatchAlarmArmAnyway = createEventDispatcher();

	let alarmGroupedDevices: AlarmGroupedDevices = {
		offline: [],
		breached: [],
		checked: [],
		deletedDevice: [],
	};

	const onCloseModal = () => {
		showModal = false;
	};

	const onArmAnyway = () => {
		dispatchAlarmArmAnyway('armAlarm');
		onCloseModal();
	};

	const onDeviceClick = (deviceID: Device['id']) => {
		setSidePanelState({ type: 'device', id: deviceID, open: true });
		onCloseModal();
	};

	onMount(() => {
		alarmGroupedDevices = getAlarmGroupedDevices(alarm);
	});

	$: modalTitle =
		alarmsList?.length > 0
			? $format('label_alarms_breached_sensors', {
					default: 'Alarms with Breached Sensors',
				})
			: $format('label_alarm_breached_sensors', {
					default: 'Alarm with Breached Sensors',
				});
</script>

{#if showModal}
	<Modal on:close={onCloseModal} {showModal} title={modalTitle}>
		<Alert
			slot="toolbar"
			type="warning"
			isHeadingBold
			heading={$format('label_alarm_breached_alert', {
				default: 'Breached/offline sensors',
			})}
			message={$format('label_alarm_breached_alert_msg', {
				default:
					'When your breached/offline sensors become in check, they will be included in the alarm.',
			})}
		/>

		<Container slot="content" padding="0">
			<AlarmBreachedSensor
				{alarm}
				{alarmsList}
				{showItemsSubtitle}
				on:deviceClick={(e) => onDeviceClick(e.detail)}
			/>
		</Container>

		<div slot="footer" class="d-flex justify-content-end width-full">
			<Button
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
				responsiveSize={{
					sm: 'm',
				}}
				variant="secondary"
				on:click={onCloseModal}>{$format('button_cancel')}</Button
			>
			<Button
				responsiveSize={{
					sm: 'm',
				}}
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
				on:click={onArmAnyway}
			>
				{$format('label_alarm_arm_anyway', { default: 'Arm anyway' })}
			</Button>
		</div>
	</Modal>
{/if}
